export const handlePDResults = (pdResults) => ({
	type: "ADD_PD_RESULT",
	pdResults
});
